<template>
  <div>
    <div class="appui">
      <div class="appui-head">
        <div>
          <h1 class="appui-title">Networking</h1>
          <div class="appui-crumb">App <span class="sep">/</span> Networking</div>
        </div>
      </div>

      <!-- Vazio -->
      <div v-if="!list.length" class="appui-emptystate">
        <div class="appui-emptystate-icon"><i class="bx bx-network-chart"></i></div>
        <div class="appui-emptystate-title">Nenhum interesse ainda</div>
        <div class="appui-emptystate-sub">Cadastre os interesses que o participante escolhe no app — pessoas com interesses em comum são sugeridas umas às outras.</div>
        <button class="appui-btn appui-btn--primary" @click="openCreate()">+ Adicionar o primeiro interesse</button>
      </div>

      <!-- Bloco principal -->
      <section v-else class="appui-card appui-card--flush">
        <div class="appui-card-toolbar">
          <div class="appui-card-toolbar-left">
            <span class="appui-toolbar-hint"><i class="mdi mdi-information-outline"></i> Interesses ativos aparecem na escolha do participante e alimentam as sugestões de conexão.</span>
          </div>
          <div class="appui-card-toolbar-right">
            <button class="appui-btn appui-btn--primary" @click="openCreate()">+ Novo interesse</button>
          </div>
        </div>

        <div class="appui-grid-3" style="padding:16px">
          <div v-for="it in list" :key="it.id" class="appui-spk-card" style="padding:16px">
            <span class="appui-badge" :class="it.status ? 'appui-badge--green' : 'appui-badge--muted'" style="position:absolute;top:12px;right:12px" role="button" title="Ativar/desativar" @click="toggle(it)">{{ it.status ? 'Ativo' : 'Oculto' }}</span>
            <div style="display:flex;align-items:center;gap:10px;margin-bottom:8px">
              <span class="appui-icon-chip"><i class="bx bx-purchase-tag-alt"></i></span>
              <span style="font-weight:600;font-size:13.5px;color:#495057;padding-right:60px">{{ it.name }}</span>
            </div>
            <div style="font-size:12px;color:#74788d;min-height:18px;margin-bottom:12px">{{ it.description || '—' }}</div>
            <div style="display:flex;gap:8px">
              <button class="appui-tbtn" @click="openEdit(it)">Editar</button>
              <button class="appui-tbtn appui-tbtn--danger" @click="remove(it)">Excluir</button>
            </div>
          </div>
        </div>
      </section>
    </div>

    <b-modal v-model="showModal" :title="form.id ? 'Editar interesse' : 'Novo interesse'" hide-footer>
      <form @submit.prevent="save()">
        <div class="form-group"><label>Nome *</label><input type="text" class="form-control" v-model="form.name" placeholder="Ex.: Tecnologia, Marketing, Vendas" required></div>
        <div class="form-group"><label>Descrição</label><input type="text" class="form-control" v-model="form.description"></div>
        <label class="appui-perm-row">
          <span><i class="mdi mdi-eye-outline"></i> Ativo no app</span>
          <button type="button" class="appui-switch" :class="{ 'is-on': form.status }" @click="form.status = form.status ? 0 : 1"><span class="knob"></span></button>
        </label>
        <div class="text-right" style="margin-top:16px">
          <button type="button" class="btn btn-light mr-2" @click="showModal = false">Cancelar</button>
          <button type="submit" class="btn btn-primary" :disabled="saving">Salvar</button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { errorMessage, successMessage } from '@/components/alertsMessages'
import services from './services'
import './app-ui.css'

const empty = () => ({ id: null, name: '', description: '', status: 1 })

export default {
  components: {},
  name: 'app-interests',
  data () {
    return { list: [], showModal: false, saving: false, form: empty() }
  },
  mounted () { this.load() },
  methods: {
    load () {
      const loader = this.$loading.show()
      services.listInterests().then(r => { this.list = r.data.data }).catch(() => errorMessage('Falha ao carregar interesses.', 3000)).finally(() => loader.hide())
    },
    openCreate () { this.form = empty(); this.showModal = true },
    openEdit (it) { this.form = { id: it.id, name: it.name, description: it.description, status: it.status }; this.showModal = true },
    async save () {
      this.saving = true
      try {
        const payload = { name: this.form.name, description: this.form.description || null, status: this.form.status }
        if (this.form.id) await services.updateInterest(this.form.id, payload)
        else await services.createInterest(payload)
        this.showModal = false
        successMessage('Interesse salvo.', 2000)
        this.load()
      } catch (e) { errorMessage('Falha ao salvar interesse.', 3000) } finally { this.saving = false }
    },
    async toggle (it) {
      const next = it.status ? 0 : 1
      try {
        await services.updateInterest(it.id, { name: it.name, description: it.description || null, status: next })
        it.status = next
      } catch (e) { errorMessage('Falha ao alterar status.', 3000) }
    },
    async remove (it) {
      const ok = await this.$bvModal.msgBoxConfirm(`Remover "${it.name}"?`, { okTitle: 'Remover', cancelTitle: 'Cancelar', okVariant: 'danger' })
      if (!ok) return
      try { await services.deleteInterest(it.id); this.load() } catch (e) { errorMessage('Falha ao remover.', 3000) }
    }
  }
}
</script>
